module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkInQuery"
  }, [_c('div', {
    staticClass: "fixed-content"
  }, [_c('div', {
    staticClass: "tabBtn"
  }, [_c('mt-navbar', {
    staticClass: "navBar",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "1"
    }
  }, [_vm._v("指派给我")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "2"
    }
  }, [_vm._v("疑难上报")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "3"
    }
  }, [_vm._v("我的维修")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-content scroll-content1"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "padding-20 bg-fff margin-top-20",
      on: {
        "click": function($event) {
          return _vm.openPage('RepairMangerDetial', item)
        }
      }
    }, [_c('div', {
      staticClass: "listBox"
    }, [_c('div', {
      staticClass: "mesList"
    }, [_c('div', {
      staticClass: "title color-333 font-size-14px"
    }, [_vm._v("报修时间：" + _vm._s(item.reportTime))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修类型：" + _vm._s(item.reportType))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("姓名：" + _vm._s(item.reporterName))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("上网账号：" + _vm._s(item.reporterNumber))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修位置：" + _vm._s(item.location))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修原因：" + _vm._s(item.reportCause))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("故障描述：" + _vm._s(item.reportCauseDescription))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("联系电话：" + _vm._s(item.reporterPhone))])]), _vm._v(" "), _c('p', {
      staticClass: "typeStateBtn color-fff",
      class: {
        'bg-f9b625': item.orderStatusName == '待维修', 'bg-appStyle': item.orderStatusName == '已维修'
      }
    }, [_vm._v(_vm._s(item.orderStatusName))])]), _vm._v(" "), (_vm.selected != 3 && item.repairOrderButtons.length > 0) ? _c('div', {
      staticClass: "border-top handleBoxs"
    }, _vm._l((item.repairOrderButtons), function(btnItem, key) {
      return _c('div', {
        key: key,
        staticClass: "handleBtn color-fff",
        on: {
          "click": function($event) {
            return _vm.handelItem($event, item, btnItem)
          }
        }
      }, [_vm._v(_vm._s(btnItem))])
    }), 0) : _vm._e()])
  })], 2)], 1), _vm._v(" "), (_vm.showMesBox) ? _c('v-messagebox', {
    attrs: {
      "mes-box-title": _vm.mesBoxTitle,
      "mes-box-type": _vm.mesBoxType
    },
    on: {
      "change": _vm.mesBosChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4124a06c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RepairManger.vue
// module id = 849
// module chunks = 1